var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(-1 0 0 -1 12 8)"},React.createElement("path",{"d":"M6 7.4L0 1.4L1.4 0L6 4.6L10.6 0L12 1.4L6 7.4Z","fill":"black"})));
}

ChevronUp.defaultProps = {"viewBox":"0 0 12 8","height":"8","width":"12"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
